module.exports = __webpack_public_path__ + "img/d-4.2bef60b4.png";